<template>
  <el-dialog
    title="批量导入指认商品"
    :visible="visible"
    width="440px"
    append-to-body
    modal-append-to-body
    v-bind="$attrs"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div style="text-align: center;">
      <zg-upload
        ref="upload"
        class="m-b20"
        singleFile
        :show-limit="false"
        :file-list="fileList"
        :extra-param="extraParam"
        accept="excel"
        @change="files => (fileList = files)"
      ></zg-upload>
      <div class="text-left">
        <p class="tip">
          请根据胖猫模版导入商品，您可以
          <span class="download" @click="getExcelTemplate">下载模版</span>
        </p>
        <p class="tip">
          请根据商品编码编辑模版，如果多个商品数据完全一致，将会自动合并。上传完毕后，你可以在相应条目下继续编辑或完成指认。
        </p>
      </div>
    </div>
    <el-row slot="footer" class="dialog-footer">
      <el-col class="text-right" :span="24">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submit">导 入</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { uploadFile } from '@/common/services/upload'
import { makeImage } from '@/common/filters'
import { mapState } from 'vuex'
import { download } from '@/common/utils/download'
import ZgUpload from 'components/zg-upload'
export default {
  components: {
    ZgUpload
  },
  data() {
    return {
      fileList: []
    }
  },
  props: {
    orderId: {
      type: [String, Number],
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    extraParam: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    visible: {
      handler() {
        this.fileList = []
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      userCurrentOrg: state => state.user.userCurrentOrg
    })
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
    onProgress(file) {
      this.progress = parseInt((file.loaded / file.total) * 100)
    },
    async getExcelTemplate() {
      const result = await this.$get('trademanager.getExcelTemplate', {
        orderId: this.orderId,
        sellerOrgId: this.userCurrentOrg.id
      })
      if (result.success) {
        let {
          data: [{ value }]
        } = result
        let url = makeImage(value, {}, false)
        download(url)
      }
    },
    async submit() {
      console.log(this.$refs.upload.isLoading)
      if (this.$refs.upload.isLoading) {
        return this.$message.warning('文件上传中，请稍后')
      }
      if (!this.fileList.length) {
        return this.$message.warning(`尚未上传文件`)
      }
      const { fk: fileKey, name: fileName } = this.fileList[0]
      const result = await this.$post('trademanager.uploadAndParseExcel', {
        orderId: this.orderId,
        fileKey,
        fileName
      })
      if (result.success) {
        if (result.data[0].isSuccess) {
          this.closeDialog()
          this.uplaodFileId = result.data[0].id
          this.loading = this.$loading({
            lock: true,
            text: '服务器处理中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          this.loopCount = 0
          this.loopInterval = setInterval(() => {
            this.loopCount++
            this.loopGoodsUploadResult()
          }, 500)
        } else {
          this.$message.error(result.data[0].msg || '商品导入失败')
        }
      }
    },
    /** 轮循商品上传结果 */
    async loopGoodsUploadResult() {
      try {
        const result = await this.$get('trademanager.queryExcelFileById', {
          id: this.uplaodFileId
        })
        if (result.success) {
          console.log('轮训次数', this.loopCount)
          if (this.loopCount >= 60) {
            clearInterval(this.loopInterval)
            this.loopCount = 0
            this.loading.close()
            this.$message.success('商品上传成功，刷新页面查询！')
          } else if (result.data[0].status > 2) {
            const content = result.data[0]
            if (content.status === 3) {
              this.$message.error('解析完成，处理结果文件失败')
            } else {
              let tipText =
                content.status === 5
                  ? `上传${content.successCount + content.failCount}条数据，成功${
                      content.successCount
                    }条，失败${content.failCount}条`
                  : `${content.remark}`
              this.$alert(
                `<div><div style="margin-bottom: 5px">${tipText}</div><div>请前去导入记录下载失败文件。</div></div>`,
                content.status === 5 ? '上传成功' : '上传失败',
                {
                  center: true,
                  confirmButtonText: '确认',
                  dangerouslyUseHTMLString: true
                }
              )
            }
            clearInterval(this.loopInterval)
            this.loopCount = 0
            this.loading.close()
            console.log(content.status)
            if (content.status === 5) {
              this.$emit('loopSuccess')
            }
          }
        } else {
          clearInterval(this.loopInterval)
          this.loopCount = 0
          this.loading.close()
          this.$message.success('商品上传成功，刷新页面查询！')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.download {
  color: #cd974c;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.tip {
  margin-bottom: 10px;
  font-size: 12px;
  color: #999;
  line-height: 1.4;
  padding-left: 12px;
  position: relative;
  &::before {
    width: 4px;
    height: 4px;
    left: 0;
    top: 5px;
    background: #999;
    position: absolute;
    content: ' ';
  }
}
</style>
